<template>
  <div>
    <div class="theme-loader">
      <div class="ball-scale">
        <div class="contain">
          <img src="../assets/loader.gif" />
        </div>
      </div>
    </div>
    <div id="pcoded" class="pcoded">
      <div class="pcoded-overlay-box"></div>
      <div class="pcoded-container navbar-wrapper">
        <navbar1 />

        <div class="pcoded-main-container">
          <div class="pcoded-wrapper">
            <navbar2 />
            <div class="pcoded-content">
              <div class="pcoded-inner-content">
                <div class="main-body">
                  <div class="page-wrapper" style="background: #fff">
                    <div class="page-body">
                      <div class="row">
                        <div class="col-md-12 col-xl-12">
                          <div class="card summery-card">
                            <div class="card-header">
                              <div class="card-header-left">
                                <h5>System Users</h5>
                              </div>
                              <div class="card-header-right">
                                <button
                                  v-if="$checkPerm('users.create')"
                                  data-toggle="modal"
                                  data-target="#addUsers"
                                  class="btn btn-primary btn-sm"
                                  v-on:click="getRoles"
                                >
                                  Add User
                                </button>
                              </div>
                            </div>
                            <div class="card-block marketing-card">
                              <div class="table-responsive">
                                <table class="table table-hover">
                                  <thead>
                                    <tr>
                                      <th>ID</th>
                                      <th>First Name</th>
                                      <th>Last Name</th>
                                      <th>Email</th>
                                      <th>Company</th>
                                      <th>Role</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(user, index) in users">
                                      <td>{{ index + 1 }}</td>
                                      <td>{{ user.first_name }}</td>
                                      <td>{{ user.last_name }}</td>
                                      <td>{{ user.email }}</td>
                                      <td>{{ user.company_name }}</td>
                                      <td>
                                        {{
                                          user.role.role_name == "undefined"
                                            ? "-"
                                            : user.role.role_name
                                        }}
                                      </td>
                                      <td>
                                        <button
                                          title="Not Implemented"
                                          class="btn btn-primary btn-mat btn-sm"
                                          data-toggle="modal"
                                          v-bind:data-target="
                                            '#editUsers' + user.id
                                          "
                                        >
                                          <i class="icofont icofont-eye-alt"></i
                                          >View/Edit
                                        </button>
                                      </td>
                                      <td>
                                        <button
                                          class="btn btn-sm btn-danger"
                                          title="Delete User"
                                          data-toggle="modal"
                                          :data-target="'#delete' + user.id"
                                        >
                                          <i class="icofont icofont-trash"></i>
                                          Delete</button
                                        >&nbsp;
                                        <!-- <button title="Not Implemented" class="btn btn-danger btn-mat btn-sm"
                                                                                    @click="deleteUser(user.id)">
                                                                                    <i class="icofont icofont-delete-alt"></i>Delete</button> -->
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="$checkPerm('users.create')"
      id="addUsers"
      class="modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Add Process.</h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body project-task">
            <form role="form" v-on:submit.prevent="createUser">
              <div class="form-group">
                <label>First Name:</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="new_user.first_name"
                  name="first_name"
                  required="required"
                />
              </div>
              <div class="form-group">
                <label>Last Name:</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="new_user.last_name"
                  name="last_name"
                  required="required"
                />
              </div>
              <div class="form-group">
                <label>Email:</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="new_user.email"
                  name="email"
                  required="required"
                />
              </div>
              <div class="form-group">
                <label>Role:</label>
                <select
                  class="form-control"
                  v-model="new_user.role_id"
                  required
                >
                  <option v-for="role in roles" v-bind:value="role.id">
                    {{ role.role_name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Company:</label>
                <select
                  class="form-control"
                  v-model="new_user.company_id"
                  required
                >
                  <option v-for="c in companies" v-bind:value="c.id">
                    {{ c.company_name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Password:</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="new_user.password"
                  name="password"
                  minlength="6"
                  required="required"
                />
              </div>
              <div class="form-group">
                <label>Repeat Password:</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="new_user.repeat_password"
                  name="repeat_password"
                  required="required"
                />
              </div>
              <span
                v-if="new_user.password !== new_user.repeat_password"
                class="label label-danger"
                >Passwords don't match.</span
              >
              <div class="form-group m-t-10">
                <button
                  class="btn btn-md btn-primary"
                  v-bind:disabled="
                    new_user.password !== new_user.repeat_password
                  "
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="$checkPerm('users.create')"
      v-for="(user, index) in users"
      v-bind:id="'editUsers' + user.id"
      class="modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Edit {{ user.first_name }} Account</h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body project-task">
            <form role="form" v-on:submit.prevent="editUsers(user.id, index)">
              <div class="form-group">
                <label>First Name:</label>
                <input
                  type="readonly"
                  class="form-control"
                  v-model="users[index].first_name"
                  name="first_name"
                  required="required"
                />
              </div>
              <div class="form-group">
                <label>Last Name:</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="users[index].last_name"
                  name="last_name"
                  required="required"
                />
              </div>
              <div class="form-group">
                <label>Email:</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="users[index].email"
                  name="email"
                  required="required"
                />
              </div>
              <div class="form-group">
                <label>Role:</label>
                <select
                  class="form-control"
                  v-model="users[index].role_id"
                  required
                >
                  <option v-for="role in roles" v-bind:value="role.id">
                    {{ role.role_name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Company:</label>
                <select
                  class="form-control"
                  v-model="users[index].company_id"
                  required
                >
                  <option v-for="c in companies" v-bind:value="c.id">
                    {{ c.company_name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Password:</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="users[index].password"
                  name="password"
                  minlength="6"
                />
              </div>
              <div class="form-group">
                <label>Repeat Password:</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="users[index].repeat_password"
                  name="repeat_password"
                />
              </div>
              <span
                v-if="users[index].password !== users[index].repeat_password"
                class="label label-danger"
                >Passwords don't match.</span
              >
              <div class="form-group m-t-10">
                <button
                  class="btn btn-md btn-primary"
                  v-bind:disabled="
                    users[index].password !== users[index].repeat_password
                  "
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      v-for="(user, index) in users"
      v-bind:id="'delete' + user.id"
      class="modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-body" style="text-align: center">
            <h5>Delete user: {{ user.last_name }} {{ user.first_name }}?</h5>
            <br /><br />
            <button
              class="btn btn-sm btn-danger"
              v-on:click="deleteUser(user.id)"
            >
              Delete
            </button>
            &nbsp;
            <button class="btn btn-sm btn-primary" data-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div>
        <h5>You do not have permission to delete an opening.</h5>
      </div>
    </div>
  </div>
</template>
<style>
.pagination {
  display: inline-block;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color 0.3s;
  background: #d5d5d5 !important;
}

.pagination a.active {
  background: #4caf50 !important;
  color: white;
}

.pagination a:hover:not(.active) {
  background-color: #00ff00;
}
</style>

<script>
import navbar1 from "../components/Navbar1.vue";
import navbar2 from "../components/Navbar2.vue";
import Tips from "../components/Tips.vue";

export default {
  name: "Stages",

  data() {
    return {
      users: [],
      roles: [],
      companies: [],
      new_user: {
        email: "",
        first_name: "",
        last_name: "",
        password: "",
        role_id: "",
        company_id: "",
        password: "",
        repeat_password: "",
      },
    };
  },

  components: {
    navbar1,
    navbar2,
    Tips,
  },

  mounted() {
    this.init();
  },
  methods: {
    init: function () {
      this.getUsers();
      this.getCompany();
      this.getRoles();
    },

    getUsers: function () {
      var users = {
        what: "GetUsers",
      };
      this.$socket
        .makeGetRequest(users)
        .then((response) => {
          this.users = response.data;
          console.log(this.users);
        })
        .catch((error) => {
          this.$swal.fire("Error", error.message, "error");
        });
    },

    getRoles: function () {
      var roles = {
        what: "GetRoles",
      };

      this.$socket
        .makeGetRequest(roles)
        .then((response) => {
          this.roles = response.data;
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCompany: function () {
      var company = {
        what: "GetCompanies",
      };

      this.$socket
        .makeGetRequest(company)
        .then((response) => {
          this.companies = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    createUser: function () {
      var new_user = {
        what: "AddUser",
        data: this.new_user,
      };

      this.$socket
        .makePostRequest(new_user)
        .then((response) => {
          this.$swal.fire("Success", response.data.message, "success");

          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch((error) => {
          let errorMessage = "Something went wrong";

          if (error.response && error.response.data) {
            // Validation errors
            if (typeof error.response.data.message === "object") {
              let errors = error.response.data.message;
              errorMessage = Object.values(errors).flat().join("\n");
            } else {
              errorMessage = error.response.data.message;
            }
          }

          this.$swal.fire("Error", errorMessage, "error");
        });
    },

    editUsers: function (id, index) {
      var editUsers = {
        what: "EditUser",
        id: id,
        data: this.users[index],
      };
      console.log(this.users[index]);
      this.$socket
        .makePostRequest(editUsers)
        .then((response) => {
          this.$swal.fire("Success", response.data.message, "success");
          setTimeout(window.location.reload(), 2000);
        })
        .catch((error) => {
          this.$swal.fire("Error", error.message, "error");
        });
    },
    deleteUser: function (id) {
      var deleteUsers = {
        what: "DeleteUser",
        id: id,
        // data: this.users[index]
      };
      // console.log(this.users[index])
      this.$socket
        .makeDeleteRequest(deleteUsers)
        .then((response) => {
          this.$swal.fire("Success", response.message, "success");
          setTimeout(window.location.reload(), 2000);
        })
        .catch((error) => {
          this.$swal.fire("Error", error.message, "error");
        });
    },
  },

  computed: {},
};
</script>